const redirectTo20Task = (path) => {
  const domain = window.location.hostname;
  const splitedDomain = domain.split(".");
  if (splitedDomain.length > 0) {
    window.location.href = `${process.env.REACT_APP_20TASK_PROTOCOL}://${splitedDomain[0]}.${process.env.REACT_APP_20TASK_URL}${path}`;
  }
};

export default redirectTo20Task;
